var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border px-0",staticStyle:{"height":"75vh","overflow-y":"scroll"},attrs:{"id":"pdf-viewer"}})}
var staticRenderFns = []

export { render, staticRenderFns }